// react components
import React from 'react'
import {
    useDispatch,
    useSelector,
} from 'react-redux'

// data
import {
    defaultReduxState,
    reduxModalErrorEventHandlerSite,
} from 'data'

// props
type TextInput816SiteProps = {
    disabled?: boolean
    error: string | undefined
    label: string
    name: string
    onChange: any
    placeholder?: string
    type?: string
    value: string | number
}

// main
export const TextInput816Site: React.FC<TextInput816SiteProps> = React.memo(({
    disabled,
    error,
    label,
    name,
    onChange,
    placeholder,
    value,
    type,
}) => {

    const dispatch = useDispatch()
    const reduxModalSite = useSelector((state: defaultReduxState) => state.reduxModalSite)

    const deviceType = reduxModalSite.deviceType

    function onInputChange(targetValue: string) {
        try {
            onChange({
                name: name,
                value: targetValue,
            })
        } catch (error) {
            dispatch(reduxModalErrorEventHandlerSite(
                error,
                'TextInput816Site',
                'onInputChange',
            ))
        }
    }

    return (
        <div className={`input-816 text-input-816 ${deviceType}`}>
            <span className={`input-816-label ${deviceType}`}>{label}</span>
            <input
                className={`ti-816-input ${deviceType}`}
                disabled={disabled}
                name={name}
                onChange={(e) => onInputChange(e.target.value)}
                placeholder={placeholder}
                type={type || 'text'}
                value={value}
            />
            {error && <span className='input-816-error'>{error}</span>}
        </div>
    )
})
